module.exports = __webpack_public_path__ + "static/media/about-us.a612af98.png";